import FilterMenu from "./FilterMenu";
import { message, Modal } from "antd";
import API from "../../../services/api-request";
import React, { useEffect, useState } from "react";
import state from "../../../../src/config/valtio/store";
import DynamicTable from "../../../components/DynamicTable";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import AddClients from "./AddClients";
import EditClients from "./EditClients";
import { appName } from "../../../config/url-config";

const { confirm } = Modal;

const Clients = () => {
  const [dataClient, setDataClient] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  const showDeleteConfirm = () => {
    confirm({
      title: `Delete ${selectedData.name}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${selectedData.name}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`client/client_id/${selectedData.id}`)
          .then(() => {
            message.success("Client has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete client");
            console.error(err);
          })
          .finally(() => {
            getDataClient();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const onSelectedData = (val) => {
    setSelectedData(val);
  };

  const getDataClient = async () => {
    state.LOADING = true;

    await API.Get(`client`)
      .then((result) => {
        setDataClient(result.data);
      })
      .catch((err) => {
        setDataClient([]);
        message.info("Failed Fetch Client Data!");
      });

    state.LOADING = false;
  };

  const onSearch = async (val) => {
    state.LOADING = true;

    await API.Get(`client?search=${val}`)
      .then((result) => {
        setDataClient(result.data);
      })
      .catch((err) => {
        message.info("Failed Fetch Client Data!");
      });

    state.LOADING = false;
  };

  useEffect(() => {
    getDataClient();

    document.title = `Master Clients | ${appName}`;
  }, []);

  const column = [
    {
      title: "No.",
      key: "id",
      width: 70,
      fixed: "left",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name - b.name,
      render: (name) => {
        if (name === null || name === "") {
          return "-";
        } else {
          return name;
        }
      },
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      sorter: (a, b) => a.address - b.address,
      render: (address) => {
        if (address === null || address === "") {
          return "-";
        } else {
          return address;
        }
      },
    },
  ];

  const options = [
    {
      label: "Edit",
      key: "1",
      icon: <EditOutlined />,
      onClick: () => onShowEdit(true),
    },
    {
      label: "Delete",
      key: "2",
      icon: <DeleteOutlined />,
      onClick: () => showDeleteConfirm(),
    },
  ];

  return (
    <>
      <h2>Clients</h2>
      <hr />

      {/* Filter menu */}
      <FilterMenu onShowAdd={onShowAdd} onSearch={onSearch} />

      {/* Table client */}
      <DynamicTable
        data={dataClient}
        columns={column}
        useOptions={true}
        options={options}
        onSelectedData={onSelectedData}
      />

      {/* Modal Add Clients */}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddClients
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetClients={getDataClient}
        />
      </div>

      {/* Modal Edit User */}
      <EditClients
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        selectedData={selectedData}
        onGetClients={getDataClient}
      />
    </>
  );
};

export default Clients;
